import { computeTotals } from "../utils/calculations";

export default function useFormSync({ methods, setFormData, handleCalAmount, commissionEnabled = true }) {
  if (!methods) {
    return { onSync: () => { } };
  }

  const { setValue, getValues } = methods;

  const onSync = (fieldName, formatted) => {
    try {
      setValue(fieldName, formatted, {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true,
      });
    } catch (e) {
      // ignore
    }

    try {
      // Read latest RHF values
      const updated = getValues();

      // Fix: remove transient root field if it matches a nested key
      if (updated.hasOwnProperty(fieldName)) {
        delete updated[fieldName];
      }



      if (Array.isArray(updated.buyerClosingCostsMeta)) {
        updated.buyerClosingCostsMeta = updated.buyerClosingCostsMeta.map((item) =>
          item.camelKey === fieldName
            ? { ...item, value: formatted }
            : item
        );
      }


      // Compute aggregated totals from the updated RHF snapshot so we can
      // write them back into RHF (so child components can use useWatch on them)
      let totalsMap = {};
      try {
        const totals = computeTotals(updated || {}, commissionEnabled);
     //   console.log("useFormSync computed totals:", totals);
        // Map totals keys to RHF and set them
        totalsMap = {
          totalCommission: totals.totalCommission,
          totalClosingCosts: totals.totalClosingCosts,
          totalPrepaids: totals.totalPrepaids,
          totalMonthlyPayment: totals.totalMonthlyPayment,
          totalInvestment: totals.totalInvestment,
        };

        Object.keys(totalsMap).forEach((k) => {
          try {
            // setValue with numeric totals (not formatted string) so watch/useWatch sees numbers
            setValue(k, totalsMap[k], { shouldDirty: true, shouldTouch: true });
          } catch (e) {
            // ignore individual set failures
          }
        });
      } catch (e) {
        // ignore computeTotals failures
      }

      // Merge totals into snapshot so parent formData also contains the computed totals
      const merged = { ...(updated || {}), ...(totalsMap || {}) };
      // console.log("[loanAmountFlow] useFormSync onSync snapshot", {
      //   fieldName,
      //   loanAmount: merged.loanAmount,
      //   requestedDownPayment: merged?.loanInfoMeta?.requestedDownPayment,
      //   conventionalPercent: merged?.loanInfoMeta?.conventionalPercent,
      // });
      setFormData && setFormData(merged);
      // handleCalAmount may be async; pass the merged snapshot so it doesn't have to re-read stale state
      handleCalAmount && handleCalAmount(merged);
    } catch (e) {
      // ignore
    }
  };

  return { onSync };
}
